var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJourneyClosed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43992 2.485C5.80992 10.025 11.1899 14.895 15.0999 16.285C13.7099 17.375 11.9799 17.995 10.1699 17.995C5.75992 17.995 2.16992 14.405 2.16992 9.995C2.16992 6.545 4.36992 3.595 7.43992 2.485ZM10.1599 0.00500488C4.56992 0.00500488 0.169922 4.535 0.169922 9.995C0.169922 15.515 4.64992 19.995 10.1699 19.995C13.8799 19.995 17.0999 17.975 18.8299 14.975C11.3199 14.725 6.73992 6.545 10.5099 0.00500488H10.1599Z",
    fill: "#F95108"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneyClosed);
export default __webpack_public_path__ + "static/media/journey-closed.99ef92fcdce11be18e0b4a3a996c9594.svg";
export { ForwardRef as ReactComponent };